import { render, staticRenderFns } from "./ChangeSecurityQuestions.vue?vue&type=template&id=640dfd22&"
import script from "./ChangeSecurityQuestions.vue?vue&type=script&lang=js&"
export * from "./ChangeSecurityQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640dfd22')) {
      api.createRecord('640dfd22', component.options)
    } else {
      api.reload('640dfd22', component.options)
    }
    module.hot.accept("./ChangeSecurityQuestions.vue?vue&type=template&id=640dfd22&", function () {
      api.rerender('640dfd22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Security/SecurityQuestions/ChangeSecurityQuestions.vue"
export default component.exports